import React, { useEffect, useState, useContext, useRef  } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import MuiAlert from '@material-ui/lab/Alert';
import {
  Box,
  Button,
	Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  Snackbar,
  LinearProgress,
  MenuItem,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
  Checkbox,
  Select,
} from '@material-ui/core';
import { CSVLink } from 'react-csv';
import { useMediaQuery } from 'react-responsive';
import DoneIcon from '@material-ui/icons/Done';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import DateFnsUtils from '@date-io/date-fns';
import confetti from 'canvas-confetti';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import InsertInvitationRoundedIcon from '@material-ui/icons/InsertInvitationRounded';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { FaFileExport } from 'react-icons/fa6';
import { storeContext } from '../provider/Provider';
import { leadsActions } from '../../store/leads-reducer';
import LeadsTableRow from './OpportunitiesTableRow';
import useStyles from './Opportunities.style';
import StyledActiveChip from '../../customUI/ActiveChip';
import GreenButton from '../../customUI/GreenButton';
import {
  StyledTableHeadCell,
  StyledTableHeadCell1,
  StyledTableHeadCell2,
  StyledTablePagination,
} from '../../customUI/table/TableStyles';
import StyledSearchChip from '../../customUI/SearchChip';
import MobileTitle from '../../customUI/MobileTitle';
import MobileLeadsCard from './MobileOpportunitiesCard';
import SubmitButton from '../../customUI/SubmitButton';
import RedButton from '../../customUI/RedButton';
import CheckIcon from '../../images/icon-proceed.svg';
import WarningIcon from '../../images/icon-warning.svg';
import CustomSortIcon from '../common/CustomSortIcon';
import { trimStartString } from '../../functions';

const { REACT_APP_FLASK_API_URL } = process.env;
const { REACT_APP_HIDE_SPAM } = process.env;

function Alert(props) {
  // eslint-disable-next-line
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const FormOpportunitiesTable = ({ handleSourceChange }) => {
  const classes = useStyles();
  const { state, dispatch } = useContext(storeContext);
  let isPhone = false;
  if (!state.websiteAnalytics.isTesting) {
    isPhone = useMediaQuery({ query: '(max-width: 768px)' });
  }

  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [leadId, setLeadId] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [openSpamDialog, setOpenSpamDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [confirmationStep, setConfirmationStep] = useState(false);
  const [search, setSearch] = useState('');
  const [mobileDate, setMobileDate] = useState(false);
  const [tableBodyHeight, setTableBodyHeight] = useState(300);
  const [isInternalFetching, setIsInternalFetching] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [orderBy, setOrderBy] = useState(null);
  const [exportClicked, setExportClicked] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportSuccess, setExportSuccess] = useState(false);
  const [exportError, setExportError] = useState(false);
  const csvLinkRef = useRef(null);
  const [filterBy, setFilterBy] = useState(null);
  const [spamChecked, setSpamChecked] = useState(false);
  const [filters, setFilters] = useState({fromDate: null, toDate: null, search: null,});

  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleOrderByClick = (value) => {
    if(value === orderBy) {
      setOrderBy(`-${value}`);
      return;
    }

    setOrderBy(value);
  }

  const handleLeadClick = () => {
    setOpenDialog(true);
	}

  const handleLeadSpamClick = () => {
    setOpenSpamDialog(true);
	}

  const handleDelete = () => {
    setOpenDeleteDialog(true);
  }

  const updateRows = (page, perPage, status = '') => {
    setIsInternalFetching(true);
    if (document.getElementById('tableBody')) {
      setTableBodyHeight(
        document.getElementById('tableBody').clientHeight > 300
          ? document.getElementById('tableBody').clientHeight
          : 300
      );
    }
    let newStatus = state.leads.currentStatus;
    if (status) {
      if (status === 'all') {
        newStatus = '';
      } else {
        newStatus = status;
      }
    }
    let dateExpression = '';
    if (filters.fromDate !== null) {
      dateExpression = `&dateFrom=${
        filters.fromDate.getMonth() + 1
      }-${filters.fromDate.getDate()}-${filters.fromDate.getFullYear()}${
        filters.toDate !== null
          ? `&dateTo=${filters.toDate.getMonth() + 1}-${filters.toDate.getDate()}-${filters.toDate.getFullYear()}`
          : ''
      }`;
    }

    let searchText = '';
    if(filters.search !== null) {
      searchText = `&search=${filters.search}`;
    }

    let typeFiltering='marked_as_lead=false';

    if(filterBy){
      if (filterBy === 'Unbounce') {
        typeFiltering = `marked_as_lead=false&fromUnbounce=true`;
      } 
    }

    let spamFiltering = '';
    if(spamChecked){
      spamFiltering= `&is_spam=true`;
    }

    let orderByParam='';
    if(orderBy){
      orderByParam=`&ordering=${orderBy}`
    }

    if (dateExpression !== '' || searchText !== '' || spamChecked) {
      if (newStatus === '') {
        newStatus = 'all';
      }
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/${newStatus}/${page}/${perPage}${typeFiltering || orderByParam || dateExpression || searchText || spamFiltering ? '?' : ''}${typeFiltering}${orderByParam}${dateExpression}${searchText}${spamFiltering}`
        )
        .then((res) => {
          dispatch({
            type: leadsActions.LEADS_SET_ALL,
            payload: {
              isFetching: false,
              total: res.data.data.total,
              leads: res.data.data.leads,
            },
          });
          setIsInternalFetching(false);
        });
    } else {
      axios
        .get(
          `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/${newStatus}/${page}/${perPage}${typeFiltering || orderByParam || dateExpression || spamFiltering ? '?' : ''}${typeFiltering}${orderByParam}${dateExpression}${spamFiltering}`
        )
        .then((res) => {
          dispatch({
            type: leadsActions.LEADS_SET_ALL,
            payload: {
              isFetching: false,
              total: res.data.data.total,
              leads: res.data.data.leads,
            },
          });
          setIsInternalFetching(false);
        });
    }
  };

  const handleClose = () => {
    setOpenDialog(false);
    setFullName('');
    setEmail('');
		setPhone('');
    setConfirmationStep(false);
  };

  const submitNewLead = () => {
    const data = {
      lead_uuid: leadId,
      marked_as_lead: true,
      fullName,
      email,
      phone,
    };
    axios.post(`${REACT_APP_FLASK_API_URL}/v1/leads/update`, data).then(() => {
      handleClose();
      confetti({
        particleCount: 200,
        angle: 40,
        spread: 100,
        origin: { x: 0 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      confetti({
        particleCount: 200,
        angle: 140,
        spread: 100,
        origin: { x: 1 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      updateRows(1, state.leads.perPage);
    });
  };

  const submitSpam = () => {
    const data = {
      is_spam: !state.leads.currentLead.is_spam,
    };
    axios.patch(`${REACT_APP_FLASK_API_URL}/v1/leads/${leadId}`, data).then(() => {
      setOpenSpamDialog(false);
      confetti({
        particleCount: 200,
        angle: 40,
        spread: 100,
        origin: { x: 0 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      confetti({
        particleCount: 200,
        angle: 140,
        spread: 100,
        origin: { x: 1 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      updateRows(1, state.leads.perPage);
    });
  };

  const submitDelete = () => {
    const data = {
      is_spam: !state.leads.currentLead.is_spam,
    };
    axios.delete(`${REACT_APP_FLASK_API_URL}/v1/leads/${leadId}`, data).then(() => {
      setOpenDeleteDialog(false);
      confetti({
        particleCount: 200,
        angle: 40,
        spread: 100,
        origin: { x: 0 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      confetti({
        particleCount: 200,
        angle: 140,
        spread: 100,
        origin: { x: 1 },
        zIndex: 1200,
        colors: ['#00b5e2', '#ffffff', '#ffa400', '#bb0000'],
      });
      updateRows(1, state.leads.perPage);
    });
  };

  const handleLeadRowClick = (id) => {
    setLeadId(id)
  }

  useEffect(() => {
    if(state.leads.formLeadsToExport.length>0 && exportClicked){
        setExportClicked(false); 
        csvLinkRef.current.link.click();
      }
  }, [state.leads.formLeadsToExport]);

  useEffect(() => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        isFetching: false,
      },
    });

    updateRows(1, state.leads.perPage);
  }, [orderBy, filterBy, filters, spamChecked]);

  useEffect(() => {
    setEmail(state.leads.currentLead?.leadBody?.email);
    setFullName(state.leads.currentLead?.leadBody?.fullName);
    setPhone(state.leads.currentLead?.leadBody?.phone);
  }, [state.leads]);

  const handleChangePage = (event, newPage) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        currentPage: newPage,
      },
    });
    setPageNumber(newPage)
    updateRows(newPage + 1, state.leads.perPage);
  };

  const handleUnSearch = () => {
    setIsInternalFetching(true);
    setSearch('');
    setFilters({...filters, search: null})
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        isSearching: false,
        searchKeyword: '',
      },
    });
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type: leadsActions.LEADS_SET_ALL,
      payload: {
        perPage: parseInt(event.target.value, 10),
        currentPage: 0,
      },
    });
    setRowsPerPage(event.target.value)
    setPageNumber(0)
    updateRows(1, parseInt(event.target.value, 10));
  };

  const handleSearch = () => {
    if (search) {
      setIsInternalFetching(true);
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          isSearching: true,
          searchKeyword: search,
        },
      });
      setFilters({...filters, search});
    }
  };

  const handleKeypress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };
  const handleFromDateChange = (date) => {
    if (date) {
      setFromDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          currentPage: 0,
        },
      });
    }
  };
  const handleFromDateChangeMobile = (date) => {
    if (date) {
      setFilters({...filters, fromDate: new Date(date.getFullYear(), date.getMonth(), date.getDate())});
      setFromDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          currentPage: 0,
        },
      });
    }
  };
  const handleToDateChange = (date) => {
    if (date) {
      setToDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          currentPage: 0,
        },
      });
    }
  };
  const handleToDateChangeMobile = (date) => {
    if (date) {
      setFilters({...filters, toDate: new Date(date.getFullYear(), date.getMonth(), date.getDate())});
      setToDate(new Date(date.getFullYear(), date.getMonth(), date.getDate()));
      dispatch({
        type: leadsActions.LEADS_SET_ALL,
        payload: {
          currentPage: 0,
        },
      });
    }
  };

  const handleDeleteDate = () => {
    setFromDate(null);
    setToDate(null);
    setFilters({...filters, fromDate: null, toDate: null});
  };

  const fetchDataAndDwnloadCSV = async () => {

    const queryParams = new URLSearchParams();

    // Add date parameters
    if (filters.fromDate !== null) {
      const fromDateStr = `${filters.fromDate.getMonth() + 1}-${filters.fromDate.getDate()}-${filters.fromDate.getFullYear()}`;
      queryParams.append('dateFrom', fromDateStr);
    }
    
    if (filters.toDate !== null) {
      const toDateStr = `${filters.toDate.getMonth() + 1}-${filters.toDate.getDate()}-${filters.toDate.getFullYear()}`;
      queryParams.append('dateTo', toDateStr);
    }

    // Add search parameter
    if (state.leads.searchKeyword) {
      queryParams.append('search', state.leads.searchKeyword);
    }

    // Add type filtering
    if (filterBy) {
      queryParams.append('chat', filterBy === 'chat');
    } else {
      queryParams.append('marked_as_lead', 'false');
    }

    // Add ordering
    if (orderBy) {
      queryParams.append('ordering', orderBy);
    }

    setExportLoading(true);
    
    try {
      // First attempt: try to get JSON response (for large files with presigned URL)
      const response = await axios.get(
        `${REACT_APP_FLASK_API_URL}/v1/leads/${state.websiteSwitch.currentWebsite}/export?${queryParams.toString()}`
      );

      // Check if response is JSON with download_url (large file scenario)
      if (response.data && response.data.download_url) {
        setExportClicked(true);
        
        // Open presigned URL in new tab to bypass CORS
        window.open(response.data.download_url, '_blank');
        
        setExportSuccess(true);
        setExportLoading(false);
      } else {
        // Small file scenario: response is likely CSV text
        setExportClicked(true);
        
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `fls_${state.websiteSwitch.currentWebsite}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        setExportSuccess(true);
        setExportLoading(false);
      }
    } catch (error) {
      setExportError(true);
      setExportLoading(false);
    }
  };

  const handleExportAlertClosed = () => {
    setExportSuccess(false);
    setExportError(false);
  }

  const handleOpenDate = () => {
    setMobileDate(true);
  };

  const handleOpenSearch = () => {
    if (document.getElementById('mobileSearch').classList.contains('open')) {
      document.getElementById('mobileSearch').classList.toggle('open');
      setTimeout(() => {
        document
          .getElementById('mobileSelect')
          .parentElement.parentElement.classList.toggle('openSearch');
      }, 500);
    } else {
      document
        .getElementById('mobileSelect')
        .parentElement.parentElement.classList.toggle('openSearch');
      setTimeout(() => {
        document.getElementById('mobileSearch').classList.toggle('open');
      }, 500);
    }
  };

  const handleFilterChanged = () => {
    setFilters({...filters, fromDate, toDate, });
  }

  if (state.leads.isFetching) {
    return (
      <LinearProgress
        style={{ width: '100%' }}
        classes={{
          colorPrimary: classes.colorPrimary,
          barColorPrimary: classes.barColorPrimary,
        }}
      />
    );
  }

  if (isPhone) {
    return (
      <>
        <MobileTitle title="Opportunities" />
        <div className={classes.flex__container} id="mobileHeader" style={{ marginBottom: '20px'}}>
          <TextField
            fullWidth
            className={classes.select}
            id="formMobileSelect"
            defaultValue="Form"
            value="form"
            variant="outlined"
            select
            SelectProps={{
              IconComponent: KeyboardArrowDownIcon,
            }}
          >
            <MenuItem key={1} value="form" onClick={() => handleSourceChange('form')}>
              Form
            </MenuItem>
            <MenuItem key={2} value="calls" onClick={() => handleSourceChange('calls')}>
              Calls
            </MenuItem>
          </TextField>
          <div className={classes.searchInputFlex} id="mobileSearch">
            <TextField
              id="search-field"
              placeholder="Start Typing"
              className={classes.searchInput}
              value={search}
              aria-label="search field"
              onKeyPress={handleKeypress}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              variant="standard"
            />
            {state.leads.isSearching && (
              <StyledSearchChip
                className={classes.chipMargin}
                label={`Search: ${search}`}
                aria-label="unSearch button"
                onDelete={handleUnSearch}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
          </div>
          <p className={classes.fullViewIcons}>
            <SearchIcon onClick={handleOpenSearch} />
          </p>
          <p className={classes.fullViewIcons}>
            <InsertInvitationRoundedIcon onClick={handleOpenDate} />
          </p>
          <Dialog
            open={mobileDate}
            className={classes.datePopup}
            onClose={() => {
              setMobileDate(false);
            }}
          >
            <DialogTitle id="form-dialog-title">
              Please select the dates to filter the pages.
            </DialogTitle>
            <div className={classes.dateInputFlex}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="From"
                  value={fromDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleFromDateChangeMobile}
                  aria-label="from date picker"
                />
                <DatePicker
                  variant="inline"
                  inputVariant="outlined"
                  label="To"
                  value={toDate}
                  style={{ paddingRight: 20 }}
                  onChange={handleToDateChangeMobile}
                />
              </MuiPickersUtilsProvider>
            </div>
          </Dialog>
        </div>
        {state.leads.total && !isInternalFetching ? (
          <div>
            {state.leads.leads.map((row, rowNumber) => (
              <MobileLeadsCard row={row} pageNumber={pageNumber} rowsPerPage={rowsPerPage} rowNumber={rowNumber} handleLeadClick={handleLeadClick} handleLeadSpamClick={handleLeadSpamClick} handleDeleteClick={handleDelete}  handleLeadRowClick={handleLeadRowClick} />
            ))}
          </div>
        ) : (
          <>{!isInternalFetching && <div style={{ margin: '5% 0 0 5%' }}>No results</div>}</>
        )}
        {isInternalFetching && (
          <div className={classes.loading} style={{ height: 400 }}>
            <CircularProgress />
          </div>
        )}
        {!state.leads.isSearching && (
          <StyledTablePagination
            rowsPerPageOptions={[15, 50]}
            component="div"
            count={state.leads.total}
            rowsPerPage={state.leads.perPage}
            page={state.leads.currentPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Rows:"
          />
        )}
        <Dialog
        open={openDialog}
        className={classes.addLeadPopup}
        onClose={() => {
          setOpenDialog(false);
          setFullName('');
          setPhone('');
          setConfirmationStep(false);
        }}
      >
        <DialogTitle>New Lead Confirmation:</DialogTitle>
        {!confirmationStep && <Box textAlign='center'>Are you sure you want to add this opportunity to Leads?</Box>}
        {confirmationStep && <Box fontWeight='bold' p={2} textAlign='center'>Please review lead data before continue this action cannot be reverted</Box>}
        <DialogContent>
          <Box display={confirmationStep ? 'none' : 'block'}>
            <TextField
              margin="dense"
              id="full name"
              label="Contact's Full Name *"
              fullWidth
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
              }}
            />
            <TextField
              margin="dense"
              id="full name"
              label="Contact's Email *"
              fullWidth
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <TextField
              margin="dense"
              id="phone"
              label="Phone"
              fullWidth
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </Box>
          <Box display={confirmationStep ? 'block' : 'none'}>
            {typeof state.leads.currentLead !== "undefined" && typeof state.leads.currentLead.leadBody !== "undefined" && Object.entries(state.leads.currentLead?.leadBody).map(([key, value]) => {
              if (typeof value !== 'object') {
                let val = '';
                if (key === 'email')
                  val = email
                else if (key === 'fullName')
                  val = fullName
                else if (key === 'phone')
                  val = phone
                else
                  val = value
                return (
                  <React.Fragment key={key + value}>
                    <Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>{key}: </Box>
                    <span>
                      {val}
                    </span>
                    <br />
                  </React.Fragment>
                );
              }
              return <></>;
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display={confirmationStep ? 'none' : 'block'}>
            <Button
              onClick={() => {
                setOpenDialog(false);
                setFullName('');
                setPhone('');
                setConfirmationStep(false);
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={() => {
                setConfirmationStep(true)
              }} >
              Review
            </GreenButton>
          </Box>
          <Box display={confirmationStep ? 'block' : 'none'}>
            <Button
              onClick={() => {
                setConfirmationStep(false)
              }}
              style={{ color: '#58595B' }}
            >
              Back
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitNewLead} >
              Submit
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSpamDialog}
        className={classes.addLeadPopup}
        onClose={() => {
          setOpenSpamDialog(false);
          setLeadId('');
        }}
      >
        <DialogContent>
          <Box style={{ textAlign: 'center'}}>
            <Box margin="auto" textAlign="center"><img style={{ margin: 'auto'}} alt='action' src={state.leads.currentLead.is_spam ? CheckIcon : WarningIcon} height="60" /></Box>
            <Box mt={2} mb={2} textAlign='center'>{state.leads.currentLead.is_spam ? <Box>You are about to <Box style={{ color: 'green', display: 'inline-block'}}>unmark</Box> this Opportunity as Spam</Box> : <Box>You are about to <Box style={{ color: 'red', display: 'inline-block'}}>mark</Box> this Opportunity as Spam</Box>}</Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='block'>
            <Button
              onClick={() => {
                setOpenSpamDialog(false);      
                setLeadId('');
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitSpam} style={{ fontSize: '1rem' }} >
              Confirm
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteDialog}
        className={classes.addLeadPopup}
        onClose={() => {
          setOpenDeleteDialog(false);
          setLeadId('');
        }}
      >
        <DialogContent>
          <Box style={{ textAlign: 'center'}}>
            <Box margin="auto" textAlign="center"><img style={{ margin: 'auto'}} alt='action' src={WarningIcon} height="60" /></Box>
            <Box mt={2} mb={2} textAlign='center'><Box>You are about to <Box style={{ color: 'red', display: 'inline-block'}}>delete</Box> this Opportunity</Box></Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='block'>
            <Button
              onClick={() => {
                setOpenDeleteDialog(false);      
                setLeadId('');
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitDelete} style={{ fontSize: '1rem' }} >
              Confirm
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
      </>
    );
  }

  return (
    <div>
			<div className={classes.card__header}>
				<div style={{ width: '100%', justifyContent: 'flex-start', }}>
					<div className={classes.heading}>Opportunities</div>
          <>
            <StyledActiveChip
              className={classes.chipMargin}
              label="Form"
              clickable
              onClick={() => handleSourceChange('form')}
            />
            <Chip
              className={classes.chipMargin}
              label="Calls"
              clickable
              onClick={() => handleSourceChange('calls')}
            />
            {filters.fromDate && !filters.toDate && (
              <StyledActiveChip
                label={`From ${filters.fromDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${filters.fromDate.getFullYear()}`}
                className={classes.chipMargin}
                onDelete={handleDeleteDate}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
            {!filters.fromDate && filters.toDate && (
              <StyledActiveChip
                label={`From ${filters.toDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${filters.toDate.getFullYear()}`}
                className={classes.chipMargin}
                onDelete={handleDeleteDate}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
            {filters.fromDate && filters.toDate && (
              <StyledActiveChip
                label={`${filters.fromDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${fromDate.getFullYear()} - ${filters.toDate.toLocaleString('en-US', {
                  month: 'long',
                })} ${filters.toDate.getFullYear()}`}
                className={classes.chipMargin}
                onDelete={handleDeleteDate}
                deleteIcon={<ClearIcon style={{ color: 'white' }} />}
              />
            )}
          </>
				</div>
				<Box className={classes.searchInputFlex}>
          {REACT_APP_HIDE_SPAM === "false" && <Box style={{ marginTop: '5px'}}>
            <Checkbox
              checked={spamChecked}
              color="primary"
              onChange={() => setSpamChecked(!spamChecked)}
              inputProps={{ 'aria-label': 'selectAll' }}
              style={{ paddingTop: '7px' }}
            />
            Show Only Spam
          </Box>}
					{state.leads.isSearching && (
						<StyledSearchChip
							className={classes.chipMargin}
							label={`Search: ${state.leads.searchKeyword}`}
							onDelete={handleUnSearch}
							deleteIcon={<DoneIcon style={{ color: 'white' }} />}
						/>
					)}
          <div
            aria-hidden="true"
            aria-label="exportButton"
            onClick={() => fetchDataAndDwnloadCSV()}
            style={{
              color: '#00B5E2',
              fontSize: '1.2rem',
              marginLeft: '20px', 
              marginRight: '10px',
            }}>
              <Box display="flex">
                <Box mr="3px">
                  <FaFileExport />
                </Box>
                <Box width="120px">
                  Export to csv
                </Box>
                {exportLoading && <CircularProgress size={20} style={{marginLeft: 5}} />}
              </Box>
          </div>
          <CSVLink
            data={state.leads.formLeadsToExport}
            headers={[
              { label: 'Uuid', key: 'uuid'},
              { label: 'Created at', key: 'createdAt'},
              { label: 'Updated at', key: 'updatedAt'},
              { label: 'Conversion Url', key: 'leadBody.conversionUrl' },
              { label: 'Email', key: 'leadBody.email' },
              { label: 'Full Name', key: 'leadBody.fullName' },
              { label: 'Landing Url', key: 'leadBody.landingUrl' },
              { label: 'Message', key: 'leadBody.message' },
              { label: 'Phone', key: 'leadBody.phone' },
              { label: 'Referrer Url', key: 'leadBody.referrerUrl' },
              { label: 'Website', key: 'leadBody.website' },
              { label: 'Status', key: 'status'},
            ]}
            filename={`fls_${state.websiteSwitch.currentWebsite}.csv`}
            ref={csvLinkRef}
            style={{
              display: 'none'
            }}
          >
            Export to CSV
          </CSVLink>
				</Box>
			</div>
			<div className={classes.card__header}>

        <Box display='flex' width="70% !important">
          <div style={{justifyContent: 'flex-start',display: 'flex',  }} className={classes.searchInputFlex}>
            <Box style={{ marginLeft: 15, marginRight: 10, alignContent: 'center'}}>Filter By Date</Box>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                variant="inline"
                inputVariant="outlined"
                label="From"
                value={fromDate}
                style={{ paddingRight: 20 }}
                onChange={handleFromDateChange}
                aria-label="from date picker"
              />
              <DatePicker
                variant="inline"
                inputVariant="outlined"
                label="To"
                value={toDate}
                style={{ paddingRight: 20 }}
                onChange={handleToDateChange}
              />
            </MuiPickersUtilsProvider>
          </div>

          <SubmitButton
            variant="contained"
            onClick={handleFilterChanged}
          >
            Filter
          </SubmitButton>
          {(filters.fromDate || filters.toDate) && (
          <RedButton
            variant="contained"
            onClick={handleDeleteDate}
            style={{
              margin: "0 0 0 15px",
              borderRadius: 5,
            }}
          >
            Clear
          </RedButton>)}
        </Box>
        <Box display='flex' alignItems='center'>
            <Box style={{ marginLeft: 15, marginRight: 10}}>Source</Box>
            <Select
              value={filterBy || "All"}
              onChange={(e) => {
                setFilterBy(e.target.value)
              }}
              style={{width: '150px'}}
            > 
              {['All', 'Unbounce'].map((el) => (
                <MenuItem
                  key={el}
                  value={el}
                >
                  {el}
                </MenuItem>
              ))}
            </Select>
        </Box>
        <div style={{display: "flex"}}>
          <TextField
						id="search-field"
						placeholder="Start Typing"
						className={classes.searchInput}
						onKeyPress={handleKeypress}
						value={search}
						onChange={(e) => {
							setSearch(e.target.value);
						}}
						InputProps={{
							endAdornment: (
								<InputAdornment position="end">
									<IconButton style={{ padding: 3 }} onClick={handleSearch}>
										<SearchIcon style={{ color: 'grey' }} />
									</IconButton>
								</InputAdornment>
							),
						}}
						variant="standard"
					/>
        </div>
			</div>
      <Snackbar
        open={exportSuccess || exportError}
        autoHideDuration={6000}
        onClose={handleExportAlertClosed}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        key="bottom left"
      >
        {exportSuccess ? (
          <Alert onClose={handleExportAlertClosed} severity="success">
            Data fetched successfully!
          </Alert>
        ) : (
          <Alert onClose={handleExportAlertClosed} severity="error">
            Error parsing data!
          </Alert>
        )}
      </Snackbar>

			{state.leads.total ? (
				<div className={classes.leadTable}>
          {Object.values(filters).reduce((result, element) => result || element !== null, false) && <Box pb={1}>{state.leads.total} results</Box>}
					<Table>
						<TableHead>
							<TableRow>
              <StyledTableHeadCell1 style={{ position: 'relative' }}>
									<Box display='flex' flex={1} justifyContent='space-between'>
										No.
									</Box>
								</StyledTableHeadCell1>
								<StyledTableHeadCell1 style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleOrderByClick('created_at')}>
									<Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
										Date
                    <CustomSortIcon field='created_at' column={orderBy? trimStartString(orderBy, '-'): ''} type={orderBy === 'created_at'? 'asc': 'desc'} />
									</Box>
								</StyledTableHeadCell1>
								<StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleOrderByClick('fullName')}>
									<Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
										Name
                    <CustomSortIcon field='fullName' column={orderBy? trimStartString(orderBy, '-'): ''} type={orderBy === 'fullName'? 'asc': 'desc'} />
									</Box>
								</StyledTableHeadCell>
								<StyledTableHeadCell style={{ position: 'relative' }} >
									<Box display='flex' flex={1} justifyContent='space-between' alignItems='center' onClick={() => handleOrderByClick('phone')}>
										Phone
                    <CustomSortIcon field='phone' column={orderBy? trimStartString(orderBy, '-'): ''} type={orderBy === 'phone'? 'asc': 'desc'} />
									</Box>
								</StyledTableHeadCell>
								<StyledTableHeadCell style={{ position: 'relative', cursor: 'pointer' }} onClick={() => handleOrderByClick('email')}>
									<Box display='flex' flex={1} justifyContent='space-between' alignItems='center'>
										Email
                    <CustomSortIcon field='email' column={orderBy? trimStartString(orderBy, '-'): ''} type={orderBy === 'email'? 'asc': 'desc'} />
									</Box>
								</StyledTableHeadCell>
								<StyledTableHeadCell>Form Review</StyledTableHeadCell>
								<StyledTableHeadCell2 align="center">Actions</StyledTableHeadCell2>
							</TableRow>
						</TableHead>
						{!isInternalFetching && (
							<TableBody>
								{state.leads.leads.map((row, rowNumber) => (
									<LeadsTableRow row={row} key={row.uuid} pageNumber={pageNumber} rowsPerPage={rowsPerPage} rowNumber={rowNumber} leadId={leadId} handleLeadClick={handleLeadClick} handleDeleteClick={handleDelete} handleLeadSpamClick={handleLeadSpamClick} handleLeadRowClick={handleLeadRowClick}/>
								))}
							</TableBody>
						)}
					</Table>
				</div>
			) : (
				<>
					{!isInternalFetching && (
						<div className={classes.noContentBlock}>
							<span>No Results</span>
						</div>
					)}
				</>
			)}
			<Dialog
        open={openDialog}
        className={classes.addLeadPopup}
        onClose={() => {
          setOpenDialog(false);
          setFullName('');
          setPhone('');
          setLeadId('');
          setConfirmationStep(false);
        }}
      >
        <DialogTitle>New Lead Confirmation:</DialogTitle>
        {!confirmationStep && <Box textAlign='center'>Are you sure you want to add this opportunity to Leads?</Box>}
        {confirmationStep && <Box fontWeight='bold' p={2} textAlign='center'>Please review lead data before continue this action cannot be reverted</Box>}
        <DialogContent>
          <Box display={confirmationStep ? 'none' : 'block'}>
            <TextField
              margin="dense"
              id="full name"
              label="Contact's Full Name *"
              fullWidth
              value={fullName}
              onChange={(e) => {
                setFullName(e.target.value);
              }}
            />
            <TextField
              margin="dense"
              id="full name"
              label="Contact's Email *"
              fullWidth
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <TextField
              margin="dense"
              id="phone"
              label="Phone"
              fullWidth
              value={phone}
              onChange={(e) => {
                setPhone(e.target.value);
              }}
            />
          </Box>
          <Box display={confirmationStep ? 'block' : 'none'}>
            {typeof state.leads.currentLead !== "undefined" && typeof state.leads.currentLead.leadBody !== "undefined" && Object.entries(state.leads.currentLead?.leadBody).map(([key, value]) => {
              if (typeof value !== 'object') {
                let val = '';
                if (key === 'email')
                  val = email
                else if (key === 'fullName')
                  val = fullName
                else if (key === 'phone')
                  val = phone
                else
                  val = value
                return (
                  <React.Fragment key={key + value}>
                    <Box fontWeight='bold' pt={1} pr={1} display='inline-block' style={{ textTransform: 'capitalize' }}>{key}: </Box>
                    <span>
                      {val}
                    </span>
                    <br />
                  </React.Fragment>
                );
              }
              return <></>;
            })}
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display={confirmationStep ? 'none' : 'block'}>
            <Button
              onClick={() => {
                setOpenDialog(false);
                setFullName('');
                setPhone('');     
                setLeadId('');
                setConfirmationStep(false);
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={() => {
                setConfirmationStep(true)
              }} >
              Review
            </GreenButton>
          </Box>
          <Box display={confirmationStep ? 'block' : 'none'}>
            <Button
              onClick={() => {
                setConfirmationStep(false)
              }}
              style={{ color: '#58595B' }}
            >
              Back
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitNewLead} >
              Submit
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSpamDialog}
        className={classes.addLeadPopup}
        onClose={() => {
          setOpenSpamDialog(false);
          setLeadId('');
        }}
      >
        <DialogContent>
          <Box style={{ textAlign: 'center'}}>
            <Box margin="auto" textAlign="center"><img style={{ margin: 'auto'}} alt='action' src={state.leads.currentLead.is_spam ? CheckIcon : WarningIcon} height="60" /></Box>
            <Box mt={2} mb={2} textAlign='center'>{state.leads.currentLead.is_spam ? <Box>You are about to <Box style={{ color: 'green', display: 'inline-block'}}>unmark</Box> this Opportunity as Spam</Box> : <Box>You are about to <Box style={{ color: 'red', display: 'inline-block'}}>mark</Box> this Opportunity as Spam</Box>}</Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='block'>
            <Button
              onClick={() => {
                setOpenSpamDialog(false);      
                setLeadId('');
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitSpam} style={{ fontSize: '1rem' }} >
              Confirm
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openDeleteDialog}
        className={classes.addLeadPopup}
        onClose={() => {
          setOpenDeleteDialog(false);
          setLeadId('');
        }}
      >
        <DialogContent>
          <Box style={{ textAlign: 'center'}}>
            <Box margin="auto" textAlign="center"><img style={{ margin: 'auto'}} alt='action' src={WarningIcon} height="60" /></Box>
            <Box mt={2} mb={2} textAlign='center'><Box>You are about to <Box style={{ color: 'red', display: 'inline-block'}}>delete</Box> this Opportunity</Box></Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box display='block'>
            <Button
              onClick={() => {
                setOpenDeleteDialog(false);      
                setLeadId('');
              }}
              style={{ color: '#58595B' }}
            >
              Cancel
            </Button>
            <GreenButton aria-label="submit convert" onClick={submitDelete} style={{ fontSize: '1rem' }} >
              Confirm
            </GreenButton>
          </Box>
        </DialogActions>
      </Dialog>
			{isInternalFetching && (
				<div className={classes.loading} style={{ height: tableBodyHeight }}>
					<CircularProgress />
				</div>
			)}
			{!state.leads.isSearching && (
				<>
					<Divider />
					<div className={classes.card__wrapper}>
						<div className={classes.cardActionButton} aria-hidden="true">
							<StyledTablePagination
								rowsPerPageOptions={[15, 50]}
								component="div"
								count={state.leads.total}
								rowsPerPage={state.leads.perPage}
								page={state.leads.currentPage}
								onPageChange={handleChangePage}
								onRowsPerPageChange={handleChangeRowsPerPage}
							/>
						</div>
					</div>
				</>
			)}
    </div>
  );
};

FormOpportunitiesTable.propTypes = {
  handleSourceChange: PropTypes.func,
};

FormOpportunitiesTable.defaultProps = {
  handleSourceChange: () => {},
};

export default FormOpportunitiesTable;
